<div class="label">
    {{label()}}
</div>
<div class="content">
    <ng-content></ng-content>
</div>
